import React from "react";
import { Link } from "react-router-dom"; // ✅ react-router-dom use karo

const pages = [
  { name: "Home", path: "/home" },
  { name: "Earth Works", path: "/earthworks" },
  { name: "Concrete", path: "/concrete" },
  { name: "About Us", path: "/aboutus" },
  { name: "Contact Us", path: "/contactus" },
  { name: "Utilities", path: "/utilities" },
  { name: "Emergency", path: "/emergency" },
  { name: "Project", path: "/projects" },
  { name: "Testimonial", path: "/testimonial" },
  { name: "Project", path: "/projects" },
  { name: "Email Requests", path: "/query" },
];

export default function PageContentTable() {
  return (
    <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Page Content</h3>
        </div>
      </div>

      <table className="w-full">
        <thead>
          <tr className="bg-neutral-50 text-left text-xs text-neutral-500 uppercase tracking-wider">
            <th className="px-6 py-3">Page</th>
            <th className="px-6 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-neutral-200">
          {pages.map((page) => (
            <tr key={page.name} className="hover:bg-neutral-50">
              <td className="px-6 py-4">
                <span className="font-medium">{page.name}</span>
              </td>
              <td className="px-6 py-4 text-right">
                <Link
                  to={page.path}
                  className="text-sm text-black hover:underline"
                >
                  <i className="fas fa-eye"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
